import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-energy-meter-normal',
  templateUrl: './energy-meter-normal.component.html',
  styleUrls: ['./energy-meter-normal.component.scss']
})
export class EnergyMeterNormalComponent implements OnInit {

  private ResponseVerifiedMpptData: Subject<any> = new Subject();
  private ResponseVerifiedInverterList: Subject<any> = new Subject();
  private ResponseVerifiedwmsInverterList: Subject<any> = new Subject();
  private ResponseWmsMpptData: Subject<any> = new Subject();
  private ResponseVerifiedNormalUserParmeterAndValue: Subject<any> = new Subject();
  role: any;
  roleName: string;
  mpptDataDetailsArray: any = [];
  wmsMpptDataDetailsArray: any = [];
  mpptStringDataArray: any;
  page = 1;
  public inverterform: FormGroup;
  public wmsinverterform: FormGroup;
  inverterDetails_id: any;
  public meterList: any = [];
 public  wmsInverterList: any = [];
  public serial_no: any;
  public subDevice_id: any;
  public meter_id: any;
  public wmsSubDevice_id: any;
  inverterObj: any;
  is_emeter:any;
  public parameterAndValue: any = [];
  public parameterListRequestObject: { serial_no: any; sub_device_id: any; };
  constructor(private router: Router, private dashboardService: DashboardService,
              private toastr: ToastrService, private fb: FormBuilder) {

                this.is_emeter = localStorage.getItem('is_emeter');
    this.role = localStorage.role;
    if (this.role === '1') {
      this.roleName = 'admin';
    } else if (this.role === '2') {
      this.roleName = 'epc';
    } else if (this.role === '3') {
      this.roleName = 'wms';
    } else if (this.role === '4') {
      this.roleName = 'normal';
    } else if (this.role === '6') {
      this.roleName = 'ze';
    }
    else if (this.role === '7') {
      this.roleName = 'dg';
    }
  }


  ngOnInit() {
    this.inverterform = this.fb.group({
      inverter_id: [null, Validators.required],
    });
    this.wmsinverterform = this.fb.group({
      wmsinverter_id: [null, Validators.required],
    });
    if (this.roleName === 'normal') {
      this.getNormalUserMeterList();
    }
    if (this.roleName === 'ze'||this.roleName === 'dg') {
      this.getZEUserMeterList();
    }
  }


// onchange normal user inverter
  onChange(value) {

    this.subDevice_id = value;
    for (let i = 0; i < this.meterList.length; i++) {
      if (this.meterList[i].id == value) {
        this.subDevice_id = this.meterList[i].sub_device_id;
        this.serial_no = this.meterList[i].serial_no;
      }

    }
    this.getParameterAndValueList();

  }

  onChangeWmsInv(value) {

    this.wmsSubDevice_id = value;
    this.getParameterAndValueList();
  }

  // get normal user inverter list on drop Down
  public getNormalUserMeterList() {

    this.dashboardService.getNormalUsersMeterList()
      .pipe(takeUntil(this.ResponseVerifiedInverterList))
      .subscribe(
        async result => {
          if (result.status) {
            this.meterList = result.resultObject;
            this.serial_no = this.meterList[0].serial_no;
            this.subDevice_id = this.meterList[0].sub_device_id;
            this.meter_id =  this.meterList[0].id;
            // this.inverterDetails_id = this.meterList[0].id;
            this.inverterform.get('inverter_id').setValue(this.meter_id);
            this.getParameterAndValueList();

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

   // Normal User Dashboard Parameters and value list
 // Normal User Dashboard Parameters and value list
 public getParameterAndValueList() {

  this.parameterListRequestObject = {
    serial_no: this.serial_no,
    sub_device_id: this.subDevice_id
  }
  this.dashboardService.getParameterAndValueList(this.parameterListRequestObject)
    .pipe(takeUntil(this.ResponseVerifiedNormalUserParmeterAndValue))
    .subscribe(
      async result => {
        this.parameterAndValue = []
        if (result.status) {
          this.parameterAndValue = result.resultObject;
          //   this.loaderService.display(true);

        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
}

onChangeZE(value) {

  this.subDevice_id = value;
  for (let i = 0; i < this.meterList.length; i++) {
    if (this.meterList[i].id == value) {
      this.subDevice_id = this.meterList[i].sub_device_id;
      this.serial_no = this.meterList[i].serial_no;
    }

  }
  this.getParameterAndValueListZE();

}
 // ze User Dashboard Parameters and value list
 public getParameterAndValueListZE() {

  this.parameterListRequestObject = {
    serial_no: this.serial_no,
    sub_device_id: this.subDevice_id
  }
  this.dashboardService.getParameterAndValueListZE(this.parameterListRequestObject)
    .pipe(takeUntil(this.ResponseVerifiedNormalUserParmeterAndValue))
    .subscribe(
      async result => {
        this.parameterAndValue = []
        if (result.status) {
          this.parameterAndValue = result.resultObject;
          //   this.loaderService.display(true);

        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
}

  // get ze user inverter list on drop Down
  public getZEUserMeterList() {

    this.dashboardService.getZEMeterList()
      .pipe(takeUntil(this.ResponseVerifiedInverterList))
      .subscribe(
        async result => {
          if (result.status) {
            this.meterList = result.resultObject;
            this.serial_no = this.meterList[0].serial_no;
            this.subDevice_id = this.meterList[0].sub_device_id;
            this.meter_id =  this.meterList[0].id;
            // this.inverterDetails_id = this.meterList[0].id;
            this.inverterform.get('inverter_id').setValue(this.meter_id);
            this.getParameterAndValueListZE();

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }



  ngOnDestroy() {
    this.ResponseVerifiedMpptData.next();
    this.ResponseVerifiedMpptData.complete();

    this.ResponseVerifiedInverterList.next();
    this.ResponseVerifiedInverterList.complete();

    this.ResponseVerifiedwmsInverterList.next();
    this.ResponseVerifiedwmsInverterList.complete();

    this.ResponseWmsMpptData.next();
    this.ResponseWmsMpptData.complete();
  }
}
